import { Listen } from '@stencil/core';
import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';
import { addStyleSettings } from '../../utils/custom-style';
import { OrderInfoRow } from '../../utils/models';


@Component({
  tag: 'tambr-message',
  styleUrl: 'tambr-message.css',
  shadow: true
})
export class TambrMessage {

  @Prop() message: string = 'Something went wrong. Please try again later.';
  @Prop() header: string;
  @Prop() backdrop: boolean = true;
  @Prop() orderInfo: OrderInfoRow[];
  
  @Event() tambrMessageClose: EventEmitter;

  @Listen('click') onClickEvent( ev: MouseEvent ) {
    const targets = ev.composedPath() as EventTarget[];
    if ( targets[0] instanceof Element && targets[0].id === 'tambr-message' ) {
      return this.close();
    }
  }

  close() { 
    this.tambrMessageClose.emit();
  }

  render() {
    return (
      <div id='tambr-message' class={ 'tambr-overlay' + (this.backdrop ? '' : ' no-backdrop') } style={ addStyleSettings() }>
        <div class='tambr-modal-window message'> 

          <div class='tambr-modal-header'>
            <tambr-icon type='close' class='close-button' onClick={ () => this.close() } />
          </div>

          { this.renderHeader() }

          <main>{ this.message }</main>

          { this.renderOrderInfo() }

        </div>
      </div>
    );
  }

  renderHeader() {
    if ( !this.header ) return;
    return ( <div class='tambr-modal-title'>{ this.header }</div> );
  }

  renderOrderInfo() {
    if ( !this.orderInfo?.length ) return;
    return (
      <div class='order-details-wrapper'>
        <tambr-checkout-order-info orderInfo={ this.orderInfo } /> 
      </div> 
    );
  }

}
